import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';
import { Dialog, DialogContent } from './ui/dialog';

// Images locales attendues
const galleryImages = [
  {
    id: 1,
    src: '/media/photos/gallery-1.jpg.jpeg',
    alt: 'Ambiance du restaurant',
    category: 'restaurant'
  },
  {
    id: 2,
    src: '/media/photos/gallery-2.jpg.png',
    alt: 'Façade',
    category: 'restaurant'
  },
  {
    id: 3,
    src: '/media/photos/gallery-3.jpg.jpeg',
    alt: 'Intérieur chaleureux',
    category: 'restaurant'
  },
  {
    id: 4,
    src: '/media/photos/gallery-4.jpg.jpeg',
    alt: 'Intérieur chaleureux',
    category: 'restaurant'
  }
];

// Placeholder pour image manquante
const ImagePlaceholder = ({ alt }) => (
  <div className="w-full h-full bg-gradient-to-br from-amber-100 to-amber-200 flex flex-col items-center justify-center p-4">
    <ImageOff className="w-12 h-12 text-amber-400 mb-2" />
    <p className="text-amber-600 text-sm font-medium text-center">Ajoutez vos photos</p>
    <p className="text-amber-500 text-xs text-center mt-1">{alt}</p>
  </div>
);

// Composant Image avec fallback
const GalleryImage = ({ src, alt, onClick, className = '' }) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <div className={`cursor-pointer ${className}`} onClick={onClick}>
        <ImagePlaceholder alt={alt} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 ${className}`}
      onError={() => setHasError(true)}
      onClick={onClick}
    />
  );
};

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="galerie" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-3">
            En Images
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Notre Galerie
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Découvrez notre univers à travers ces photos de nos plats
            et de notre établissement.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              onClick={() => setSelectedImage(image)}
              className={`group relative overflow-hidden rounded-2xl cursor-pointer aspect-square ${
                index === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
            >
              <GalleryImage
                src={image.src}
                alt={image.alt}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-medium text-sm">{image.alt}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Note pour ajouter des photos */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-400">
          </p>
        </div>

        {/* Lightbox */}
        <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
          <DialogContent className="max-w-4xl p-0 bg-transparent border-none shadow-none">
            {selectedImage && (
              <div className="relative">
                <GalleryImage
                  src={selectedImage.src}
                  alt={selectedImage.alt}
                  className="w-full h-auto rounded-lg"
                />
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent rounded-b-lg">
                  <p className="text-white font-medium">{selectedImage.alt}</p>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default GallerySection;
